import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'Fill in the details of your request.',
    errors: {
      insufficientAmount: 'This amount is too low',
    },
    hints: {
      label: 'Optional',
    },
    labels: {
      amount: 'Amount',
      label: 'Label',
      recipient: 'Recipient',
      supportingDocument: 'Proof',
    },
    placeholders: {
      amount: 'Amount (€)',
    },
    submit: 'Send my request',
    supportingDocumentTypes: {
      items: {
        0: 'A RIB document in case of a transfer to one of your accounts',
        1: 'Corresponding invoice, receipt, payslip...',
      },
      label: 'Types of documents accepted:',
    },
    title: 'Set up the transfer',
  },
  fr: {
    description: 'Remplissez les informations de votre demande.',
    errors: {
      insufficientAmount: 'Ce montant est insuffisant',
    },
    hints: {
      label: 'Facultatif',
    },
    labels: {
      amount: 'Montant',
      label: 'Libellé',
      recipient: 'Bénéficiaire',
      supportingDocument: 'Justificatif',
    },
    placeholders: {
      amount: 'Montant en €',
    },
    submit: 'Envoyer ma demande',
    supportingDocumentTypes: {
      items: {
        0: 'Un document RIB en cas de transfert vers un de vos comptes',
        1: 'Facture correspondante, reçu, bulletin de salaire...',
      },
      label: 'Types de documents acceptés :',
    },
    title: 'Paramétrez le virement',
  },
} as const);

export default locales;
